<app-tipping-price-create-modal [grades]='this.grades' [units]='this.units'></app-tipping-price-create-modal>
<app-tabs (tabClicked)="selectTab($event)">
  <app-tab title='Main details'>
    @if ((this.account.type.id === 3 || this.account.type_id === 16) && this.account.id === -1) {
      <div class='alert alert-primary'>
        Please create the customer first and then edit to add sites.
      </div>
    }
    @if (!this.account.isactive) {
      <div class='alert alert-danger'>
        This account has been Deactivated. You can re-enable it in the Account Activation tab.
      </div>
    }

    @if (this.isStandaloneSite && this.account.id === -1) {
      <div class='alert alert-danger'>
        Warning! This will create a site unlinked to any account.
      </div>
    }

    @if (this.account.id === -1 && !this.isStandaloneSite) {
      <div>
        <label>Automatically create site?</label>
        <input type='checkbox' [(ngModel)]='this.sameSite.sameSite'
          [ngModelOptions]="{standalone: true}"
          />
        <br />
        <br />
        <!-- <label>Automatically create tip?</label>
        <input type='checkbox' [(ngModel)]='this.sameTip.sameTip'
          [ngModelOptions]="{standalone: true}"
          /> -->
        </div>
      }

      @if ((this.account.type_id === 3 || this.account.type_id === 16) && this.account.id !== -1 && this.account.id) {
        <button class='btn btn-secondary' (click)='createOrder()'>+ Create Order</button>
      }


      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="accountName">Name</label>
          <input
            type="text"
            name='name'
            [(ngModel)]='this.account.name'
            [class.is-invalid]='!this.account.name'
            class="form-control"
            id="accountName"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
            >
          <app-companies-house-search (companySelected)='onCompanySelected($event)' [companyName]='this.account.name'></app-companies-house-search>
        </div>

        @if (this.account.type_id !== 13 && this.account.type_id === -1 && !this.isSimpleOrder) {
          <div class="form-group col-md-4">
            <label for="accountType">Account Type</label>
            <select class='form-control' [class.is-invalid]='this.account.type_id === -1'  (change)='this.account.type_id = +$event.target.value; this.account.type = {}; this.account.type.id = this.account.type_id;setRefForProspect();checkIfSite($event);'>
              <option value='-1'>Select an account type</option>
              @for (item of this.types; track item) {
                <option [value]='item.id' [selected]='this.account.type_id === item.id'>{{ item.name }}</option>
              }
            </select>
          </div>
        }
        @if (this.account.type_id === 13) {
          <div class="form-group col-md-4">
            <label for="accountType">Account Type</label>
            <select class='form-control' [class.is-invalid]='this.account.type_id === -1'  (change)='this.account.type_id = +$event.target.value; this.account.type = {}; this.account.type.id = this.account.type_id'>
              <option value='13' [selected]='this.account.type_id === 13'>Site</option>
              <!-- <option value='15' [selected]='this.account.type_id === 15'>Tip</option> -->
            </select>
          </div>
        }
        @if (this.isSimpleOrder && this.account.type_id !== 13) {
          <div class="form-group col-md-4">
            <label for="accountType">Account Type</label>
            <select class='form-control' [class.is-invalid]='this.account.type_id === -1'  (change)='this.account.type_id = +$event.target.value; this.account.type = {}; this.account.type.id = this.account.type_id'>
              <option value='-1'>Select an account type</option>
              <option value='3' [selected]='this.account.type_id === 3'>Customer</option>
              <option value='16' [selected]='this.account.type_id === 16'>Non Credit Account</option>
              <!-- <option value='15' [selected]='this.account.type_id === 15'>Tip</option> -->
            </select>
          </div>
        }
        <div class="form-group col-md-4">
          <label for="accountRef">Account Ref</label>
          <input type="text" name='name' [(ngModel)]='this.account.accountRef' [class.is-invalid]='!this.account.accountRef && (this.account.type_id === 13 || this.account.type_id === 3)' class="form-control" id="accountRef">
        </div>
        @if (this.account.type_id === 13) {
          <div class="form-group col-md-4">
            <label for="sepaId">SEPA Area</label>
            <ng-select [(ngModel)]="this.account.sepaId" (change)='this.account.sepaId = +$event; this.account.sepa = {}; this.account.sepa.id = this.account.sepaId'>
              @for (item of this.sepaCodes; track item) {
                <ng-option [value]='item.id'>({{item.code}}) {{ item.name }}</ng-option>
              }
            </ng-select>
          </div>
        }
        <div class="form-group col-md-4">
          <label for="contact">Contact</label>
          <input type="text" name='name' [(ngModel)]='this.account.contact' class="form-control" id="contact">
        </div>
        <div class="form-group col-md-4">
          <label for="email">Email</label>
          <input type="email" name='name' [(ngModel)]='this.account.email' class="form-control" id="email">
        </div>
        <div class="form-group col-md-4">
          <label for="website">Website</label>
          <input type="text" name='name' [(ngModel)]='this.account.website' class="form-control" id="website">
        </div>
        <div class="form-group col-md-4">
          <label for="phoneNumber">Phone Number</label>
          <input type="text" name='name' [(ngModel)]='this.account.phoneNumber' class="form-control" id="phoneNumber">
        </div>
        @if (this.account.type_id === 13 || this.account.type_id === 14 || this.account.type_id === 15) {
          <div class="form-group col-md-4 form-check">
            <input class="form-check-input" type="checkbox" [(ngModel)]='this.account.isOwn' id="isOwn">
            <label class="form-check-label" for="isOwn">
              Is this a {{this.companyName}} Site?
            </label>
          </div>
        }
        <div class="form-group col-md-4">
          <label for="inputEmail4">SIC Code</label>
          <ng-select [(ngModel)]="this.account.sicId" (change)='this.account.sicId = +$event'>
            @for (item of this.sic; track item) {
              <ng-option [value]='item.id'>{{ item.code }} - {{ item.name }}</ng-option>
            }
          </ng-select>
        </div>

        @if (this.account.type_id === 3 || this.account.type_id === 8) {
          <div
            class="form-group col-md-4"
            >
            <label for="inputEmail4">Industry (optional)</label>
            <select class='form-control' (change)='this.account.industryId = +$event.target.value; this.account.industry = {id: this.account.industryId}'>
              <option value='-1'>Select an industry</option>
              @for (item of this.allIndustry; track item) {
                <option [selected]='this.account.industryId === item.id' [value]='item.id'>{{ item.name }}</option>
              }
            </select>
          </div>
        }
        @if (this.account.type_id === 3 || this.account.type_id === 8) {
          <div
            class="form-group col-md-4"
            >
            <label for="inputEmail4">Account Rating</label>
            <select
              class='form-control'
              (change)='updateRating($event)'
              >
              <option value='-1'>Select an Account Rating</option>
              @for (item of this.ratings; track item) {
                <option
                  [selected]='this.account.rating_id === item.id'
                  [value]='item.id'
                >{{ item.name }}</option>
              }
            </select>
          </div>
        }
        <div class="form-group col-md-4">
          <label for="inputEmail4">Account Source</label>
          <input type='text' class='form-control' [(ngModel)]='this.account.source'/>
        </div>
        <div class="form-group col-md-4">
          <label for="inputEmail4">Annual Revenue</label>
          <input type='number' class='form-control' [(ngModel)]='this.account.annualRevenue' [class.is-invalid]='this.account.annualRevenue < 0'/>
        </div>
        <div class="form-group col-md-8">
          <label for="inputEmail4">Notes</label>
          <textarea [(ngModel)]='this.account.notes' class='form-control'></textarea>
        </div>


      </div>
      <div class='form-row'>
        <div class='form-group'>
          <label>is Tip?</label>
          <input type='checkbox'
            [(ngModel)]="this.account.isTip"
            [ngModelOptions]="{standalone: true}"/>
        </div>
      </div>
      <br />
      <br />

      <div class='form-row'>
        <div class='form-group'>
          <label>is Depot?</label>
          <input type='checkbox'
            [(ngModel)]="this.account.isDepot"
            [ngModelOptions]="{standalone: true}"/>
        </div>
      </div>
    </app-tab>
    <app-tab title='Addresses'>
      <app-tabs>
        <app-tab title='Billing Details'>
          <div class="form-group col-md-4">
            <label for="billing1">Address Line 1</label>
            <input type="text" name='name' [(ngModel)]='this.account.billingAddress1' class="form-control" id="billing1">
          </div>
          <div class="form-group col-md-4">
            <label for="billing2">Address Line 2</label>
            <input type="text" name='name' [(ngModel)]='this.account.billingAddress2' class="form-control" id="billing2">
          </div>
          <div class="form-group col-md-4">
            <label for="billing3">City</label>
            <input type="text" name='name' [(ngModel)]='this.account.billingCity' class="form-control" id="billing3">
          </div>
          <div class="form-group col-md-4">
            <label for="billing4">Country</label>
            <input type="text" name='name' [(ngModel)]='this.account.billingCountry' class="form-control" id="billing4">
          </div>
          <div class="form-group col-md-4">
            <label for="billing5">Postcode</label>
            <input type="text" name='name' [(ngModel)]='this.account.billingPostCode' class="form-control" id="billing5">
            <app-address-picker [postcode]='this.account.billingPostCode' (onAddressFound)='this.foundBillingAddress($event)'></app-address-picker>
          </div>
          <div class="row">
            <div class="col">
              <button class='btn btn-block btn-info' (click)='transferAddress()'>Transfer Address Details to Shipping</button>
            </div>
          </div>
        </app-tab>
        <app-tab title='Shipping Details'>
          <div class="form-group col-md-4">
            <label for="ship1">Address Line 1</label>
            <input type="text" name='name' [(ngModel)]='this.account.shippingAddress1' class="form-control" id="ship1">
          </div>
          <div class="form-group col-md-4">
            <label for="ship2">Address Line 2</label>
            <input type="text" name='name' [(ngModel)]='this.account.shippingAddress2' class="form-control" id="ship2">
          </div>
          <div class="form-group col-md-4">
            <label for="ship3">City</label>
            <input type="text" name='name' [(ngModel)]='this.account.shippingCity' class="form-control" id="ship3">
          </div>
          <div class="form-group col-md-4">
            <label for="ship4">Country</label>
            <input type="text" name='name' [(ngModel)]='this.account.shippingCountry' class="form-control" id="ship4">
          </div>
          <div class="form-group col-md-4">
            <label for="ship5">Postcode</label>
            <input type="text" name='name' [(ngModel)]='this.account.shippingPostCode' class="form-control" id="ship5">
            <app-address-picker [postcode]='this.account.shippingPostCode' (onAddressFound)='this.foundShippingAddress($event)'></app-address-picker>
          </div>
        </app-tab>
      </app-tabs>
    </app-tab>
    <app-tab title='Account Info'>
      <app-tabs>
        @if ((this.account.type_id === 3 || this.account.type_id === 16) && this.account.id !== -1) {
          <app-tab title='Additional Details'>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="invoiceperiod">Invoice Period</label>
                <select class='form-control' (change)='this.customerDetails.invoicePeriodId = +$event.target.value'>
                  <option value='-1'>Select an invoice period</option>
                  <option value='1' [selected]='this.customerDetails.invoicePeriodId === 1'>Weekly</option>
                  <option value='2' [selected]='this.customerDetails.invoicePeriodId === 2'>2 Weekly</option>
                  <option value='3' [selected]='this.customerDetails.invoicePeriodId === 3'>Monthly</option>
                  <option value='4' [selected]='this.customerDetails.invoicePeriodId === 4'>Quarterly</option>
                  <option value='5' [selected]='this.customerDetails.invoicePeriodId === 5'>Yearly</option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label for="invoiceMethod">Invoice Method</label>
                <select class='form-control' (change)='this.customerDetails.invoiceMethodId = +$event.target.value;'>
                  <option value='-1'>Select an invoice method</option>
                  <option value='1' [selected]='this.customerDetails.invoiceMethodId === 1'>Email</option>
                  <option value='2' [selected]='this.customerDetails.invoiceMethodId === 2'>Post</option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label for="invoiceSplitByPO">Split Invoices By PO</label>
                <input type="checkbox" name='name' [ngModelOptions]="{standalone: true}" [(ngModel)]='this.customerDetails.invoiceSplitByPO' id="invoiceSplitByPO">
              </div>
              <div class="form-group col-md-4">
                <label for="invoiceSplitBySite">Split Invoices By Site</label>
                <input type="checkbox" name='name' [ngModelOptions]="{standalone: true}"  [(ngModel)]='this.customerDetails.invoiceSplitBySite'  id="invoiceSplitBySite">
              </div>
              <div class="form-group col-md-4">
                <label for="invoiceSplitByOrderType">Split Invoices By Order Type</label>
                <input type="checkbox" name='name' [ngModelOptions]="{standalone: true}" [(ngModel)]='this.customerDetails.invoiceSplitByOrderType'  id="invoiceSplitByOrderType">
              </div>
              <div class="form-group col-md-4">
                <label for="customerCat">Customer Category</label>
                <select class='form-control' (change)='this.customerDetails.customerCategoryId = +$event.target.value; this.customerDetails.customerCategory = {}; this.customerDetails.customerCategory.id = this.customerDetails.customerCategoryId'>
                  <option value='-1'>Select an customer category</option>
                  @for (item of this.categories; track item) {
                    <option [value]='1' [selected]='this.customerDetails.customerCategoryId === item.id'>{{ item.name }}</option>
                  }
                </select>
              </div>
              <div class="form-group col-md-4">
                <label for="ship4">Licence Number</label>
                <input type="text" name='name' [(ngModel)]='this.customerDetails.licenceNumber' class="form-control" id="ship4">
              </div>
              <div class="form-group col-md-4">
                <label for="ship4">Carrier Licence Number</label>
                <input type="text" name='name' [(ngModel)]='this.customerDetails.carrierLicenceNumber' class="form-control" id="ship4">
              </div>
              <div class="form-group col-md-4">
                <label for="ship4">Carrier Licence Expiry</label>
                <input type="date" name='name' [(ngModel)]='this.customerDetails.carrierLicenceExpiryDate' class="form-control" id="ship4">
              </div>
              <div class="form-group col-md-4">
                <label for="ship4">Waste carrier</label>
                <input type="text" name='name' [(ngModel)]='this.customerDetails.wasteCarrier' class="form-control" id="ship4">
              </div>
            </div>
          </app-tab>
        }
        @if ((this.account.type_id === 3 && this.account.id !== -1)) {
          <app-tab title='Credit limit'>
            <div class="form-row">
              <label>Credit Limit enabled</label>
              <input type="checkbox" name='name' [ngModelOptions]="{standalone: true}" [(ngModel)]='this.account.limitEnabled'  id="invoiceSplitByOrderType">
              @if (this.account.limitEnabled) {
                <div class='form-group col-md-4'>
                  <label>Credit Limit</label>
                  <input type='text' class='form-control' [(ngModel)]="this.creditLimit.maxCredit" />
                </div>
              }
            </div>
          </app-tab>
        }
        @if (this.account.id > 0 ) {
          <app-tab title='Account Incumbents'>
            <div class="row">
              <div class="form-group col-md-4">
                <label>Add an Incumbent</label>
                <select
                  class='form-control'
                  (change)='addIncumbent($event)'
                  >
                  <option value='-1' [selected]='this.currentIncumbent === -1'>Select an Incumbent</option>
                  @for (item of this.incumbentList; track item) {
                    <option
                      [value]='item.id'
                      [selected]='this.currentIncumbent === item.id'
                    >{{ item.name }}</option>
                  }
                </select>
              </div>
              <div class="form-group col-md-4">
                <label class='form-control'>Notes</label>
                <input class='form-control' [(ngModel)]='this.newIncumbent.notes' type='text'/>
              </div>
              <div class="form-group col-md-12">
                <button class='btn btn-block btn-success' (click)='saveIncumbent();$event.preventDefault();'>Add incumbent</button>
              </div>
            </div>
            <div class="row">
              <div class="col">
                @if (this.accountIncumbents.length > 0) {
                  <table class='table table-bordered'>
                    <thead class='thead-dark'>
                      <tr>
                        <th>Name</th>
                        <th>Notes</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (item of this.accountIncumbents; track item) {
                        <tr>
                          <td>{{item.incumbent.name}}</td>
                          <td>{{item.notes}}</td>
                          <td>
                            <button class='btn btn-danger' (click)='deleteIncumbent(item.id);$event.preventDefault();'>Delete</button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                }
              </div>
            </div>
          </app-tab>
        }
        <app-tab title='Account Activation'>
          <div class="form-group col-md-4 custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="customSwitch1" [(ngModel)]='this.account.isactive'>
            @if (this.account.isactive) {
              <label class="custom-control-label" for="customSwitch1">Account Active</label>
            }
            @if (!this.account.isactive) {
              <label class="custom-control-label" for="customSwitch1">Account Deactivated</label>
            }
          </div>
        </app-tab>
        <!-- if tip and already saved show additional details -->
        @if (this.account.type_id === 15 && this.account.id !== -1) {
          <app-tab title='Additional Details'>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="licenceNumber">Licence Number</label>
                <input type="text" name='name' [(ngModel)]='this.tipDetails.licenceNumber' class="form-control" id="licenceNumber">
              </div>
              <div class="form-group col-md-4">
                <label for="carrierLicenceNumber">Carrier Licence Number</label>
                <input type="text" name='name' [(ngModel)]='this.tipDetails.carrierLicenceNumber' class="form-control" id="carrierLicenceNumber">
              </div>
              <div class="form-group col-md-4">
                <label for="carrierLicenceExpiryDate">Carrier Licence Expiry date</label>
                <input type="date" name='name' [(ngModel)]='this.tipDetails.carrierLicenceExpiryDate' class="form-control" id="carrierLicenceExpiryDate">
              </div>
            </div>
          </app-tab>
        }

        <!-- if tip and already saved show additional details -->
        @if (this.account.type_id === 14 && this.account.id !== -1) {
          <app-tab title='Additional Details'>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="licenceNumber">Site Licence Number</label>
                <input type="text" name='name' [(ngModel)]='this.depotDetails.licenceNumber' class="form-control" id="licenceNumber">
              </div>
              <div class="form-group col-md-4">
                <label for="carrierLicenceNumber">Carrier Licence Number</label>
                <input type="text" name='name' [(ngModel)]='this.depotDetails.carrierLicenceNumber' class="form-control" id="carrierLicenceNumber">
              </div>
              <div class="form-group col-md-4">
                <label for="carrierLicenceExpiryDate">Carrier Licence Expiry date</label>
                <input type="date" name='name' [(ngModel)]='this.depotDetails.carrierLicenceExpiryDate' class="form-control" id="carrierLicenceExpiryDate">
              </div>
            </div>
          </app-tab>
        }
      </app-tabs>
    </app-tab>
    <!-- If a tip is already created let them create prices -->
    @if (this.account.type_id === 15 && this.account.id !== -1) {
      <app-tab title='Prices'>
        <button type='button' class='btn btn-secondary' (click)='this.openModal("tippingPriceCreateModal")'>Add price</button>
        <br />
        <br />
        @if (this.tippingPrices.tippingPrices.length > 0) {
          <table class="table">
            <thead>
              <th>Grade</th>
              <th>Unit</th>
              <th>Price(&pound;)</th>
              <th>Effective Date</th>
              <th></th>
            </thead>
            <tbody>
              @for (item of this.tippingPrices.tippingPrices; track item; let i = $index) {
                <tr>
                  <td>
                    <select class='form-control' (change)='item.gradeId = +$event.target.value; item.grade.id = item.gradeId'>
                      @for (grade of this.grades; track grade) {
                        <option [value]='grade.id' [selected]='grade.id === item.gradeId'>{{ grade.name }} @if (grade.ewcCodes && grade.ewcCodes !== "") {
                          ({{ grade.ewcCodes }})
                        }</option>
                      }
                    </select>
                  </td>
                  <td>
                    <select class='form-control' (change)='item.unitId = +$event.target.value; item.unit.id = item.unitId'>
                      @for (unit of this.units; track unit) {
                        <option [selected]='item.unitId === unit.id' [value]='unit.id'>{{ unit.name }}(s)</option>
                      }
                    </select>
                  </td>
                  <td>
                    <input type='text' class='form-control' [(ngModel)]='item.price'/>
                  </td>
                  <td>
                    <input type='date' class='form-control' [(ngModel)]="item.effectiveDate" />
                  </td>
                  <td>
                    <button class='btn btn-danger' type="button" (click)='this.onDeletePriceClick(i)'><i class="fas fa-trash"></i></button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </app-tab>
    }
    @if ((this.account.type_id === 3 || this.account.type_id === 16) && this.account.id !== -1 && this.account.id) {
      <app-tab title='Sites'>

        @if(isSitesLoaded) {
        <button class='btn btn-secondary' routerLink='/accounts/site/{{ this.account.id }}'><i class="fas fa-plus"></i> New</button>&nbsp;
        <br />
        <br />
        <app-sites-section [account]='this.account'></app-sites-section>
        }
      </app-tab>
    }

    @if (this.account.type_id === 3 || this.account.type_id === 16) {
      <app-tab title='Links'>

        @if(isLinksLoaded) {
        <app-tabs>
          <app-tab title='Contacts'>
            <app-contact-section [account]='this.account'></app-contact-section>
          </app-tab>
          @if (this.environment.crmOptions.showLeads) {
            <app-tab title='Leads'>
              <app-lead-section [account]='this.account'></app-lead-section>
            </app-tab>
          }
          <app-tab title='Opportunities'>
            <app-opportunity-section [account]='this.account'></app-opportunity-section>
          </app-tab>
          <app-tab title='Contracts'>
            <app-contract-section [account]='this.account'></app-contract-section>
          </app-tab>
          <!-- <<app-tab title='Quotes'>
          <app-quote-section [account]='this.account'></app-quote-section>
        </app-tab>
        <app-tab title='Price Lists'>
          <app-price-list-section [account]='this.account'></app-price-list-section>
        </app-tab> -->
        <!-- <app-tab title='Orders'>
        <app-order-section [account]='this.account'></app-order-section>
      </app-tab> -->
      <!-- <app-tab title='Invoices'></app-tab> -->
    </app-tabs>
  }
  </app-tab>
}
@if (this.account.id !== -1 && this.account.id) {
  <app-tab title='Discussion'>
    @if(isDiscussionLoaded) {
      <app-discussion [data]='this.account' entity='account'></app-discussion>
    }
  </app-tab>
}
@if (this.account.id !== -1 && this.account.id) {
  <app-tab title='Correspondence'>
    @if(isCorrespondenceLoaded) {
      <app-correspondence-grid [data]='this.account' entity='account'></app-correspondence-grid>
    }
  </app-tab>
}
</app-tabs>
